import { useContext } from "react";
import DealsContext from "../contexts/dealsContext";

const useDealsHook = () => useContext(DealsContext);

export default useDealsHook;
